<template>
  <div class="page-editor" :style="getPageEditorStyles">
    <PageBuilderComponent
      v-if="!isFullScreenPage"
      ref="pageBuilderComponentRef"
      :task="element.value"
      :taskProps="element.value.props"
      @onContentChange="onContentChange"
      :getCustomWidgets="onGetCustomWidgets"
      :saveCustomWidgets="onSaveCustomWidgets"
    ></PageBuilderComponent>

    <div
      class="page-editor-fullscreen-toggle"
      v-if="isFullScreenToggle"
      @click="onToggleFullScreen"
    >
      <b-icon icon="arrows-fullscreen"></b-icon>
    </div>
    <div class="full-screen-page-editor-modal" v-if="isFullScreenPage">
      <GeneralModal @close="onClosePageModal">
        <PageBuilderComponent
          ref="pageBuilderComponentRef"
          :task="element.value"
          :taskProps="element.value.props"
          @onContentChange="onContentChange"
          :getCustomWidgets="onGetCustomWidgets"
          :saveCustomWidgets="onSaveCustomWidgets"
        ></PageBuilderComponent
      ></GeneralModal>
    </div>
  </div>
</template>

<script>
import { PageBuilderComponent } from '@codelos.io/page-builder';
import GeneralModal from '@/components/modals/GeneralModal';

import {
  saveCustomWidgets,
  getCustomWidgets,
} from '@/utils/helpers/PageBuilderHelper.js';
export default {
  name: 'page-editor',
  data() {
    return {
      isFullScreenPage: false,
      savedScrollPosition: 0,
    };
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    isFullScreenToggle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  created() {
    if (this.element?.value?.props?.jsonContent) {
      this.element?.value?.jsonContent?.children?.forEach((pageNode) => {
        if (pageNode.type === 'table' && !('boldRows' in pageNode.value)) {
          pageNode.value['boldRows'] = new Array(pageNode.value.rows).fill(
            false
          );
        }
      });
    }
    if (this.element?.type === 'freecontent' && !this.element.value) {
      this.element.value = {
        props: {
          jsonContent: null,
          htmlContent: null,
        },
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.element.value.props.jsonContent =
        this.element.value.props.jsonContent ||
        this.$refs.pageBuilderComponentRef?.pageBuilderNodes;
      this.element.value.props.htmlContent =
        this.element.value.props.htmlContent ||
        this.$refs.pageBuilderComponentRef.getSanitizedString();
    });
  },
  methods: {
    onContentChange(event) {
      this.element.value.props.jsonContent = event.jsonContent;
      this.element.value.props.htmlContent = event.htmlContent;
    },
    onToggleFullScreen() {
      if (!this.isFullScreenPage) this.savedScrollPosition = window.scrollY;

      this.isFullScreenPage = !this.isFullScreenPage;
    },
    onClosePageModal() {
      this.isFullScreenPage = false;
      setTimeout(() => {
        window.scrollTo(0, this.savedScrollPosition);
      });
    },
    async onGetCustomWidgets() {
      const widgets = await getCustomWidgets();
      return widgets;
    },

    async onSaveCustomWidgets(widgetElement) {
      try {
        await saveCustomWidgets(widgetElement);
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  computed: {
    getPageEditorStyles() {
      return { zIndex: this.isFullScreenPage ? 10 : 0 };
    },
  },

  components: {
    PageBuilderComponent,
    GeneralModal,
  },
};
</script>

<style scoped>
.page-editor {
  background-color: #ffffff;
  position: relative;
  z-index: 0;
  border: 1px solid #dee3e9;
  border-radius: 2px;
}

.page-editor .page-editor-fullscreen-toggle {
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  color: #a3a3a3;
}

.page-editor .page-editor-fullscreen-toggle:hover {
  color: black;
  opacity: 0.75;
}
.page-editor .full-screen-page-editor-modal {
  position: relative;
}
</style>
